export default __webpack_public_path__ + "0eab383f765d7c73bc5ef471f76a6a24.svg";